import { AppHostssesDashboardPage } from '@/components/app-hostesses/dashboard-page';

/**
 * ダッシュボードページ
 *
 * タブシステム:
 * - 名刺
 * - 担当（🤵‍♂️）
 * - 枝客（🪾）
 * - 他の担当（🙅）
 * - 店客（🏛️）
 * - 非会員（👤）
 */
export default function Dashboard() {
  return <AppHostssesDashboardPage />;
}
